import script from "./AppointmentAssignedProfessionalCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppointmentAssignedProfessionalCard.vue?vue&type=script&setup=true&lang=ts"

import "./AppointmentAssignedProfessionalCard.vue?vue&type=style&index=0&id=61efdf00&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-61efdf00"]])

export default __exports__